import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTabsModule as MatTabsModule } from '@angular/material/tabs';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainLayoutComponent } from './_layout/main-layout/main-layout.component';
import { StsComponent } from './sts/sts.component';
import { ClientsComponent } from './clients/clients.component';
import { MaterialModule } from './material/material.module';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ImgsignerComponent } from './clients/imgsigner/imgsigner.component';
import { DownloadsComponent } from './downloads/downloads.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { CliComponent } from './clients/cli/cli.component';
import { MarkdownModule } from 'ngx-markdown';

@NgModule({
  declarations: [
    AppComponent,
    MainLayoutComponent,
    StsComponent,
    ClientsComponent,
    ImgsignerComponent,
    DownloadsComponent,
    SidenavComponent,
    CliComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    FlexLayoutModule,
    MatIconModule,
    HttpClientModule,
    MatTabsModule,
    BrowserAnimationsModule,
    MarkdownModule.forRoot({
      loader: HttpClient
    }),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer){
    matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('/assets/mdi.svg'));
  }
}
